import { useEffect } from 'react'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { useAppSelector } from '@/store'

NProgress.configure({ showSpinner: false, speed: 400 })

/**
 * GlobalLoader — thin top progress bar driven by Redux.
 * Shows when dispatch(showLoader()) is called, hides on dispatch(hideLoader()).
 */
export const GlobalLoader = () => {
  const showLoader = useAppSelector((state) => state.ui.showLoader)

  useEffect(() => {
    if (showLoader) {
      NProgress.start()
    } else {
      NProgress.done()
    }
  }, [showLoader])

  return null
}
